import { Injectable, inject } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';

import * as TicketActions from './ticket.actions';
import * as TicketFeature from './ticket.reducer';
import * as TicketSelectors from './ticket.selectors';
import { Observable, take } from 'rxjs';
import { ICounterModel, TError } from '@amwager/util-ts';

@Injectable()
export class TicketFacade {
  private readonly store = inject(Store);

  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   *
   * Selectors
   */

  isError$(): Observable<TError> {
    return this.store.pipe(select(TicketSelectors.getTicketError));
  }

  // counters
  counter$(): Observable<ICounterModel | undefined> {
    return this.store.pipe(select(TicketSelectors.getCounters));
  }

  /**
   * Use the initialization action to perform one
   * or more tasks in your Effects.
   *
   * Dispatches: Requests only, from WagerActionss
   */

  /**
   * @param sourceInitiator The source component where the method was first invoked.
   *
   * @usageNotes
   *  important: don't initialized multiple times
   *
   * ### Example:
   *  this.ticketFacade.initState('LoginComponent');
   */
  initState(sourceInitiator: string): void {
    this.store.select(TicketSelectors.getTicketLoaded)
      .pipe(take(1))
      .subscribe(isLoaded => {
        isLoaded
          ? null
          : this.store.dispatch(TicketActions.initTicketState({ sourceInitiator }))
      });
  }
  clearState(sourceInitiator: string): void {
    this.store.dispatch(TicketActions.clearTicketState({ sourceInitiator }));
  }

  setError(error: TError): void {
    this.store.dispatch(TicketActions.setError({ error }));
  }

  getCountersAPI(runId: string, sourceInitiator: string,): void {
    this.store.dispatch(TicketActions.getCountersAPI({
      sourceInitiator,
      runId
    }));
  }
}
